import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';

import TriangleIcon from '../Icon/TriangleIcon';
import styles from './Autocomplete.module.css';
import { DropdownIndicatorProps } from './types';

export const DropdownIndicator = ({ disabled, showOptions, onClick }: DropdownIndicatorProps) => {
  const [rippleStyles, setRippleStyles] = useState<{ opacity: number; animation?: string }>({ opacity: 0 });
  const rippleTimerRef = useRef<any>(0);

  const handleRipple = (event: any) => {
    onClick?.(event);
    rippleTimerRef.current = null;
    setRippleStyles({ opacity: 0 });
    setRippleStyles((prevState: any) => ({
      ...prevState,
      opacity: 1,
      animation: `550ms ${styles.ripple}`,
    }));
    rippleTimerRef.current = setTimeout(() => {
      setRippleStyles({ opacity: 0 });
    }, 400);
  };

  useEffect(() => {
    return clearTimeout(rippleTimerRef.current);
  }, []);

  return (
    <span
      className={clsx(styles.rippleContainer, {
        ['pointer-events-none']: disabled,
      })}
      title={showOptions ? 'Close' : 'Open'}
      onClick={handleRipple}
      data-testid={'ripple-container'}
    >
      <span className={styles.rippleElement} style={{ ...rippleStyles }}></span>
      <TriangleIcon className={clsx(styles.dropdownIcon, { [styles.down]: showOptions })} />
    </span>
  );
};
